export default {
  about: {
    subtitle1: "معلومات عنا",

    title1: "مرحبًا بكم في",
    title2: "سوق MAHAL الغذائي",

    desc:
      "MAHAL هي منصة موثوقة لتوريد المواد الغذائية بين الشركات تربط المطاعم بالموردين المعتمدين من خلال الشفافية والجودة والموثوقية.",

    text:
      "في MAHAL، نعيد تعريف إدارة سلسلة الإمداد الغذائي من خلال توفير طلبات سلسة وأسعار شفافة وشراكات طويلة الأمد — كل ذلك في منصة واحدة ذكية وقابلة للتطوير.",

    f1: "منتجات عضوية موثوقة",
    f2: "إمدادات صحية وطازجة",
    f3: "منتجات محلية",
    f4: "جودة يمكنك الوثوق بها",

    cta1: "اعرف المزيد",
    cta2: "اتصل بنا",
  },
};